/**
 * Confidence Badge Legend
 * Explains the meaning of the confidence level badges
 */

export function ConfidenceLegend() {
  return (
    <div className="hub-legend">
      <div className="hub-legend__title">Data Confidence:</div>
      <div className="hub-legend__items">
        <div className="hub-legend__item">
          <span className="hub-tile__badge hub-tile__badge--high">high</span>
          <span className="hub-legend__desc">Measured/confirmed</span>
        </div>
        <div className="hub-legend__item">
          <span className="hub-tile__badge hub-tile__badge--medium">medium</span>
          <span className="hub-legend__desc">Partial assessment</span>
        </div>
        <div className="hub-legend__item">
          <span className="hub-tile__badge hub-tile__badge--low">low</span>
          <span className="hub-legend__desc">Estimated/assumed</span>
        </div>
        <div className="hub-legend__item">
          <span className="hub-tile__badge hub-tile__badge--unknown">unknown</span>
          <span className="hub-legend__desc">Not collected</span>
        </div>
      </div>
    </div>
  );
}
